import { ExploreAllMarketPlacesTypesEnum } from 'components/DiscoverPage/props';

export const getExploreTypes = (compact = false) => {
  const iconClass = compact ? 'h-[18px] w-[18px]' : 'h-6 w-6 max-sm:h-5 max-sm:w-5';
  return [
    {
      label: 'All Activities',
      value: ExploreAllMarketPlacesTypesEnum.All,
      icon: (
        <img
          src="/images/player-home-v2/search-bar-icons/all-activities.svg"
          className={iconClass}
        />
      ),
    },
    {
      label: 'Lessons',
      value: ExploreAllMarketPlacesTypesEnum.Lessons,
      icon: (
        <img
          src="/images/player-home-v2/search-bar-icons/lesson-gradient.png"
          className={iconClass}
        />
      ),
    },
    {
      label: 'Courts',
      value: ExploreAllMarketPlacesTypesEnum.Courts,
      icon: <img src="/images/player-home-v2/court-green.png" className={iconClass} />,
    },
    {
      label: 'Clinics',
      value: ExploreAllMarketPlacesTypesEnum.Clinics,
      icon: (
        <img
          src="/images/player-home-v2/search-bar-icons/clinic-gradient.png"
          className={iconClass}
        />
      ),
    },
    {
      label: 'Tournaments',
      value: ExploreAllMarketPlacesTypesEnum.Tournaments,
      icon: (
        <img
          src="/images/player-home-v2/search-bar-icons/tournament-gradient.svg"
          className={iconClass}
        />
      ),
    },
    {
      label: 'Leagues',
      value: ExploreAllMarketPlacesTypesEnum.League,
      icon: (
        <img
          src="/images/player-home-v2/search-bar-icons/league-gradient.png"
          className={iconClass}
        />
      ),
    },
    {
      label: 'Open Play',
      value: ExploreAllMarketPlacesTypesEnum.OpenPlay,
      icon: <img src="/images/programming/open-play.png" className={iconClass} />,
    },
    {
      label: 'Socials',
      value: ExploreAllMarketPlacesTypesEnum.Socials,
      icon: <img src="/images/programming/socials.png" className={iconClass} />,
    },
  ];
};
